<template>
    <div class="vuetable-filterbar col-md-12 ">
        <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="uf_id_ini"
                        :options="optionsUf"
                        track-by="value"
                        label="label"
                        :option-height="25"
                        :hide-selected="true"
                        placeholder="UF Início"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="uf_id_fim"
                        :options="optionsUf"
                        track-by="value"
                        label="label"
                        :option-height="25"
                        :hide-selected="true"
                        placeholder="UF Fim"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col cols="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_icms"
                        :options="optionsTpIcms"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Icms"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="status"
                        :options="optionsStatus"
                        track-by="value"
                        label="label"
                        :option-height="25"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      cd: '',
      descr: '',
      optionsStatus: [],
      status: [],
      optionsUf: [],
      uf_id_ini: [],
      uf_id_fim: [],
      optionsTpIcms: [],
      tp_icms: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              descr: this.descr,
                              status: this.status,
                              uf_id_fim: this.uf_id_fim,
                              uf_id_ini: this.uf_id_ini,
                              tp_icms: this.tp_icms};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.descr = '';
        this.status = '';
        this.uf_id_ini = '';
        this.uf_id_fim = '';
        this.tp_icms = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral()
      {
          this.helpForm.get('/api/icms/jsonlistgeral').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.status.forEach((obj)=>
              {
                  this.optionsStatus.push({ label: obj.descr, value: obj.valor })
              })
              response.uf.forEach((obj)=>
              {
                  this.optionsUf.push({ label: obj.nome, value: obj.uf_id })
              })
              response.tp_icms.forEach((obj)=>
              {
                  this.optionsTpIcms.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
